module.exports = __webpack_public_path__ + "img/关键能力训练.adecf9c8.png";